// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1NmoE","badges":"styles_badges__2ig4f"};